import React, { FC, useCallback, useMemo } from "react";
import { useNavigate } from "react-router";
import { BANNER_TYPE, Banner } from "@lookiero/aurora";
import { useI18nMessage } from "@lookiero/i18n-react";
import { useStaticInfo } from "../../hooks/useStaticInfo";
import { DOMAIN, I18nMessages } from "../../i18n/i18n";
import { Routes } from "../../routing/routes";
import { useTrackShopButtonClicked } from "../../tracking/useTrackShopButtonClicked";

interface SalesBannerProps {
  readonly scaled: boolean;
}

const SalesBanner: FC<SalesBannerProps> = ({ scaled }) => {
  const navigate = useNavigate();
  const {
    cdnPath,
    session: {
      user: { id: userId, country, segment },
    },
    basePath,
    tradename,
  } = useStaticInfo();

  const salesCategoriesBannerDescription = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.SALES_CATEGORIES_BANNER_DESCRIPTION,
  });
  const salesCategoriesBannerTitle = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.SALES_CATEGORIES_BANNER_TITLE,
  });
  const salesCategoriesBannerCta = useI18nMessage({
    domain: DOMAIN,
    id: I18nMessages.SALES_CATEGORIES_BANNER_CTA,
  });

  const trackShopButtonClicked = useTrackShopButtonClicked({
    country,
    segment,
    userId,
    tradename,
  });
  const onPress = useCallback(() => {
    trackShopButtonClicked({
      buttonId: "banner_fromcattosales",
    });

    navigate(`${basePath}/${Routes.SALES}`);
  }, [basePath, navigate, trackShopButtonClicked]);

  const imageUrl = useMemo(() => `${cdnPath}/images/shop/banners/special-prices/${segment}.webp`, [cdnPath, segment]);

  return (
    <Banner
      description={salesCategoriesBannerDescription}
      image={{ src: imageUrl }}
      scaled={scaled}
      style={!scaled ? { height: "100%" } : null}
      title={salesCategoriesBannerTitle}
      type={BANNER_TYPE.SQUARED}
      primaryButton={{
        text: salesCategoriesBannerCta,
        onPress: onPress,
      }}
    />
  );
};

export { SalesBanner };
